/**
 * Single place that knows where the backend lives.
 *
 * The host is unchanged from before — it was previously hard-coded in ~30
 * files. `REACT_APP_API_BASE_URL` can override it for other environments
 * without touching component code.
 */
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || 'https://backend.indianjewelryish.com'
).replace(/\/+$/, '');

/** Build an API endpoint URL: apiUrl('/api/category') */
export const apiUrl = (path = '') =>
  `${API_BASE_URL}/${String(path).replace(/^\/+/, '')}`;

/**
 * Build a URL for an asset served by the backend (product images, carousels,
 * receipts). Returns an empty string for missing paths so callers can skip
 * rendering rather than requesting `backend.example.com/undefined`.
 */
export const assetUrl = (path) => {
  if (!path) return '';
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path;
  return `${API_BASE_URL}/${String(path).replace(/^\/+/, '')}`;
};

/** Auth headers for endpoints that require a logged-in user. */
export const authHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};
